var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconAtSign = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(35.238 16.864) rotate(135)" },
                React.createElement("path", { d: "M17.4,15.7c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3l0,0\n\t\tC15.4,11.3,17.4,13.3,17.4,15.7z" }),
                React.createElement("path", { d: "M17.4,11.3v5.4c0,1.8,1.5,3.2,3.2,3.2c1.8,0,3.2-1.5,3.2-3.2v-1.1c0-6-4.8-10.8-10.8-10.8\n\t\tC7,4.8,2.2,9.7,2.2,15.7S7,26.5,13,26.5c2.4,0,4.7-0.8,6.6-2.2" })))));
});
export default IconAtSign;
//# sourceMappingURL=IconAtSign.js.map